import styles from "./ColorSwatches.module.css";

// Strip of color chips. Each entry is `{ id, name, hex?, image? }`. Hover
// callbacks let parents preview a color (e.g. swap the card image) without
// committing the selection.
export default function ColorSwatches({
  colors = [],
  selectedId,
  onSelect,
  onHover,
  size = "sm",
  ariaLabel = "Available colors",
}) {
  if (!colors.length) return null;
  const cls = [styles.row, styles[size]].join(" ");
  return (
    <div
      className={cls}
      role="radiogroup"
      aria-label={ariaLabel}
      onMouseLeave={onHover ? () => onHover(null) : undefined}
    >
      {colors.map((c) => {
        const isSel = selectedId != null && c.id === selectedId;
        const style = c.image
          ? { backgroundImage: `url(${c.image})`, backgroundSize: "cover" }
          : { background: c.hex || "#ccc" };
        return (
          <button
            key={c.id || c.name}
            type="button"
            role="radio"
            aria-checked={isSel}
            aria-label={c.name}
            title={c.name}
            className={[styles.chip, isSel ? styles.selected : ""].join(" ")}
            style={style}
            onClick={onSelect ? () => onSelect(c) : undefined}
            onMouseEnter={onHover ? () => onHover(c) : undefined}
            onFocus={onHover ? () => onHover(c) : undefined}
          />
        );
      })}
    </div>
  );
}
